export default {
    methods :{
        sendEmailEntity(emailObject, url) {
            axios({
                method:"POST",
                url:url,
                data:emailObject
              }).then(response=>{
                this.shareLoading = false
                if(response.data !== undefined) {
                  var data = response.data
                  if(data.success) {
                    this.$swal("Successfully shared")
                  }
                  else {
                    console.log(response)
                    this.$swal("server error")
                  }
                }
                else {
                  this.$swal(response)
                }
              }).catch(exc=>{
                this.shareLoading = false
                this.$swal("server error 2")
                console.log(exc)
              })
        }
    }
}